import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

Vue.use(axios)

Vue.config.productionTip = false

document.querySelectorAll('.mortgage-calculator-wrapper').forEach((el) => {
  new Vue({
    el,
    render(h) {
      return h(App, {
        props: {
          name: el.attributes.name.value
        }
      });
    }
  });
});